/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RejectLedgerWithdrawRequestOptions,
  RejectLedgerWithdrawRequestStatus200,
  RejectLedgerWithdrawRequestStatus400,
  RejectLedgerWithdrawRequestStatus403,
  RejectLedgerWithdrawRequestStatus404,
  RejectLedgerWithdrawRequestStatus500,
} from '../types/RejectLedgerWithdrawRequest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { rejectLedgerWithdrawRequest } from '../clients/rejectLedgerWithdrawRequest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const rejectLedgerWithdrawRequestMutationKey = () =>
  [{ url: '/v1/ledger/withdraw/requests/:withdrawal_id/reject' }] as const

export function rejectLedgerWithdrawRequestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = rejectLedgerWithdrawRequestMutationKey()
  return mutationOptions<
    RejectLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | RejectLedgerWithdrawRequestStatus400
      | RejectLedgerWithdrawRequestStatus403
      | RejectLedgerWithdrawRequestStatus404
      | RejectLedgerWithdrawRequestStatus500
    >,
    RejectLedgerWithdrawRequestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return rejectLedgerWithdrawRequest({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Reject a pending withdrawal request, providing a reason for the rejection. Note that this does not interact with any external systems; it simply updates the status of the withdrawal request in the ledger. Actual transfer of assets must be handled separately.
 * @summary Reject a pending withdrawal request
 * {@link /v1/ledger/withdraw/requests/:withdrawal_id/reject}
 */
export function useRejectLedgerWithdrawRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RejectLedgerWithdrawRequestStatus200,
      ResponseErrorConfig<
        | RejectLedgerWithdrawRequestStatus400
        | RejectLedgerWithdrawRequestStatus403
        | RejectLedgerWithdrawRequestStatus404
        | RejectLedgerWithdrawRequestStatus500
      >,
      RejectLedgerWithdrawRequestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? rejectLedgerWithdrawRequestMutationKey()

  const baseOptions = rejectLedgerWithdrawRequestMutationOptions(config) as UseMutationOptions<
    RejectLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | RejectLedgerWithdrawRequestStatus400
      | RejectLedgerWithdrawRequestStatus403
      | RejectLedgerWithdrawRequestStatus404
      | RejectLedgerWithdrawRequestStatus500
    >,
    RejectLedgerWithdrawRequestOptions,
    TContext
  >

  return useMutation<
    RejectLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | RejectLedgerWithdrawRequestStatus400
      | RejectLedgerWithdrawRequestStatus403
      | RejectLedgerWithdrawRequestStatus404
      | RejectLedgerWithdrawRequestStatus500
    >,
    RejectLedgerWithdrawRequestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RejectLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | RejectLedgerWithdrawRequestStatus400
      | RejectLedgerWithdrawRequestStatus403
      | RejectLedgerWithdrawRequestStatus404
      | RejectLedgerWithdrawRequestStatus500
    >,
    RejectLedgerWithdrawRequestOptions,
    TContext
  >
}
